import React, { useState } from "react";
import { Modal , Button} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//Import SVg
import { LanguageMobileIcon , BackSVG } from '../components/SvgIcons';

// Slider Images
import Banner1 from "../assets/images/template1.png";
import Banner2 from "../assets/images/template1.png";
import Banner3 from "../assets/images/template1.png";
  const slides = [
    { image: Banner1, title1: "Antique ", title2: "sculpture", date: "June 12 – July 25" },
    { image: Banner2, title1: "Vintage ", title2:"Art Exhibition",  date: "Aug 10 – Aug 30" },
    { image: Banner3, title1: "Classic ", title2: "Heritage Gallery", date: "Sept 5 – Sept 18" },
  ];

  

const ChooseTemplateModal = ({ show, onHide, items, setActiveModal = () => {} }) => {
  const navigate = useNavigate();

const handleSelect = (item) => {
  if (item.action?.type === "route") {
    navigate(item.action.path);
  }

  if (item.action?.type === "modal") {
    setActiveModal(item.action.modal); // modal name store
  }

  onHide(); // current modal close
};

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="state-templateModal contentSlider"
    >
      {/* Close Button */}
      {/* <button className="template-close" onClick={onHide}>
        ✕
      </button> */}

   {/* Header */}
      <Modal.Header  className="modal-header-custom">
         {/* Mobile Language Icon */}
            <div className="languageImg  d-flex d-sm-none">
               <BackSVG/>
            </div>
        {/* End Mobile Language Icon */}

          <h4 className="fw-bold mb-0">Himachal Pradesh</h4>
          <button className="close-btn" onClick={onHide}>
           <i className="bi bi-x"></i>
          </button>

        {/* Mobile Language Icon */}
            <div className="languageImg  d-flex d-sm-none">
               <LanguageMobileIcon/>
            </div>
        {/* End Mobile Language Icon */}
      </Modal.Header>

      <Modal.Body className="p-0">
        {/* <h4 className="fw-bold">Please Choose A Template:</h4> */}

        <div className="template-grid">
          {items.map((item, index) => (
            <div
              key={index}
              className="template-card"
              style={{ backgroundColor: item.bg , 
                       border:  `1px solid ${item.border}` }}
           onClick={() => handleSelect(item)}
            >
              <img src={item.icon} alt={item.title} />
              <span className="fw-bold">{item.title}</span>
            </div>
          ))}
        </div>

        {/* Banner Slider */}
          <div className="banner-slider rounded overflow-hidden template-modal">
              <div id="bannerCarousel" className="carousel slide border-0 p-0 mb-0" data-bs-ride="carousel">
                
                {/* Indicators */}
                <div className="carousel-indicators">
                  {slides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      data-bs-target="#bannerCarousel"
                      data-bs-slide-to={i}
                      className={i === 0 ? "active" : ""}
                    />
                  ))}
                </div>

                {/* Slides */}
                <div className="carousel-inner">
                  {slides.map((slide, i) => (
                    <div
                      className={`carousel-item ${i === 0 ? "active" : ""}`}
                      key={i}
                    >
                      <img src={slide.image} className="d-block w-100 slider-img" alt="slide" />

                      {/* OVERLAY */}
                      <div className="carousel-caption d-flex justify-content-between align-items-center w-100 text-start ">
                        <div>
                          <h5 className="fw-bold"> {slide.title1} <span> {slide.title2} </span></h5>
                          <p className="mb-0 small">{slide.date}</p>
                        </div>

                        <Button size="sm" className="buy-btn fw-semibold">
                           Buy Ticket
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
           {/* End Banner Slider */}  
      </Modal.Body>
    </Modal>
  );
};

export default ChooseTemplateModal;

